import { Component, OnDestroy } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject, takeUntil } from "rxjs";

@Component({
	selector: "app-modal-confirm-change",
	templateUrl: "./modal-confirm-change.component.html",
	styleUrls: ["./modal-confirm-change.component.scss"],
	standalone: false
})
export class ModalConfirmChangeComponent implements OnDestroy {
	private onRequestAction = new Subject<boolean>();
	private _onDestroy = new Subject<boolean>();

	protected title = "";
	protected description = "";
	protected loading = false;

	public schemaName?: string;

	public onRequestAction$ = this.onRequestAction
		.asObservable()
		.pipe(takeUntil(this._onDestroy));

	constructor(public bsModalRef: BsModalRef) {}

	ngOnDestroy(): void {
		this._onDestroy.next(true);
	}

	confirm(): void {
		this.loading = true;
		this.onRequestAction.next(true);
	}

	cancel(): void {
		this.onRequestAction.next(false);
		this.bsModalRef.hide();
	}

	resolveRequest(): void {
		this.bsModalRef.hide();
	}

	rejectRequest(): void {
		this.loading = false;
		this.bsModalRef.hide();
	}

	rejectRequestWithoutClosingModal(): void {
		this.loading = false;
	}
}
